import { FormStore } from '@roc/feature-app-core';
import { GlobalStore } from '@roc/feature-app-core';
import { DialogState } from '@roc/ui';
import {
  makeObservable, observable, action,
  computed
} from 'mobx';

const form = {
  fields: {
    insuranceCarrierId: {
      value: '',
      error: null,
      rule: '',
    },
    carrierName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'Carrier name is required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class InsuranceCarrierFormStore extends FormStore {
  public dialogState: DialogState;
  public deleteDialogState: boolean;
  constructor(globalStore: GlobalStore) {
    super(form, globalStore);
    makeObservable(this, {
      dialogState: observable,
      setDialogState: action,
      isOpen: computed
    });
  }

  setDialogState(dialogState: DialogState, record?: any) {
    this.dialogState = dialogState;
    if (!this.isOpen) {
      this.reset();
    }
    if (dialogState == DialogState.EDIT) {
      this.loadForm(record);
    }
  }

  setDeleteDialogState(dialogState: boolean, record?: any) {
    this.deleteDialogState = dialogState;
    if (this.deleteDialogState) {
      this.loadForm(record);
    } else {
      this.reset();
    }
  }

  get isOpen() {
    return [DialogState.ADD, DialogState.EDIT].includes(this.dialogState);
  }
}